import { jsx } from "react/jsx-runtime";
import React from "react";
import { SLIDER_NORM_WIDTH, SLIDER_SMALL_WIDTH } from "../constants/constants";
import UncontrolledSliderWithPlusMinusBtns from "../helperComponents/UncontrolledSliderWithPlusMinusBtns";
export function ZoomRowViewSlider({
  charWidth,
  setCharWidth,
  minCharWidth = 3,
  maxCharWidth = 100,
  afterOnChange,
  smallSlider,
  zoomHelper
}) {
  const initialZoomLvl = Math.log(charWidth / minCharWidth) / Math.log(Math.pow(maxCharWidth / minCharWidth, 1 / 10));
  return /* @__PURE__ */ jsx("div", { className: "tg-zoom-bar", style: { zIndex: 900, position: "relative", marginBottom: 5, marginLeft: 5 }, children: /* @__PURE__ */ jsx(
    UncontrolledSliderWithPlusMinusBtns,
    {
      bindOutsideChangeHelper: zoomHelper,
      noWraparound: true,
      onClick: () => {
        afterOnChange && afterOnChange();
      },
      onChange: (zoomLvl) => {
        const scaleFactor = Math.pow(maxCharWidth / minCharWidth, 1 / 10);
        const newCharWidth = minCharWidth * Math.pow(scaleFactor, zoomLvl);
        setCharWidth(newCharWidth);
        afterOnChange && afterOnChange();
      },
      leftIcon: "minus",
      rightIcon: "plus",
      title: "Zoom",
      smallSlider,
      style: {
        paddingTop: "4px",
        width: (smallSlider ? SLIDER_SMALL_WIDTH : SLIDER_NORM_WIDTH) * 3
      },
      className: "veZoomRowSlider ove-slider",
      labelRenderer: false,
      stepSize: 0.05,
      clickStepSize: 0.5,
      initialValue: initialZoomLvl,
      max: 10,
      min: 0
    }
  ) });
}
